export enum FilterTypes {
    ALL = 'all',
    COMPATIBLE = 'compatible',
    INCOMPATIBLE = 'incompatible'
}

export type ManageQueuesForm = {
    telsys: number
    partition: number
    filter: FilterTypes
    queues: Record<string, string>
}

export type UpdateQueueRequestBody = {
    DisableRTMonitoring: boolean
}

export type LoadingEntries = Record<string, boolean>
